<template>
    <label @click.stop.prevent="handleClick($event)" v-model="model" class="btn-group" :class="{'active' : isActive}">
        <i class="fa fa-check text-active"></i> {{ label }}
    </label>
</template>

<script>
  export default {
    name: 'u-button-group-item',
    props: {
      disabled: Boolean,
      label: String,
      value: {
        required: true
      },
      val: {},
      toggleClass: {
        type: String,
        default: null
      }
    },
    methods: {
      handleClick (e) {
        if (this.disable) {
          return
        }
        if (this.isArray) {
          if (this.index === -1) {
            this.model.push(this.val)
          } else {
            this.model.splice(this.index, 1)
          }
          this.__onChange()
          return
        }
        this.model = this.val
        this.__onChange()
      },
      __onChange () {
        this.$emit('change', this.model)
      }
    },
    computed: {
      model: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit('input', value)
        }
      },
      isArray () {
        return Array.isArray(this.value)
      },
      index () {
        if (this.isArray) {
          return this.model.indexOf(this.val)
        }
      },
      isActive () {
        return this.isArray
          ? this.model.indexOf(this.val) > -1
          : this.model === this.val
      }
    }
  }
</script>

<!--<style lang="stylus"></style>-->



// WEBPACK FOOTER //
// UButtonGroupItem.vue?6e19c872